<template>
  <div class="ma-4">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>

    <div v-show="!showSkeleton" class="text-h4 mb-2">Filas</div>

    <v-dialog v-model="dialog">
      <v-card>
        <v-card-text>
          <Dialog  :fila="fila" />
        </v-card-text> 

        <v-divider />

        <v-card-actions>
        <v-spacer />
            <v-btn color="blue darken-1" text @click="dialog = false">Sair</v-btn>
        </v-card-actions> 
      </v-card>  
    </v-dialog> 

    <v-data-iterator
      v-show="!showSkeleton"
      :no-data-text="noDataText"
      :items="dataFilas"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row>
          <v-col cols="7" class="my-2">
            <v-btn
              v-if="permissaoTotal"
              dark
              color="orangePcm"
              href="/central-de-atendimento/cadastro/fila/criar"
              target="_blank"
              @click="handleGoToNewQueue"
              class="mr-2"
            >
              Criar Fila
            </v-btn>
          </v-col>
          <v-spacer />
          <v-col cols="4" class="mr-2">
            <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify" label="Busca" />
          </v-col>
        </v-row>
      </template>

      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="headers"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
          @dblclick:row="atualizar"
        >
          <template v-slot:[`item.botoes`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  dark
                  color="bluePcm"
                  class="ma-2"
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                  @click="openDialog(item)"
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>Uso</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="atualizarButton($event, item)"
                  icon
                  small
                  dark
                  color="bluePcm"
                  :href="`/central-de-atendimento/cadastro/fila/atualizar/${item._id}`"
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom v-if="permissaoTotal">
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="deletar(item)" icon small dark color="darkRed" v-bind="attrs" v-on="on">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <div class="ml-4 mb-2 grey--text">
            <p>Total de Filas: {{ qtdFilas }}</p>
          </div>
          <v-spacer />
          <div class="pb-5">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ListPagination from '@/componentes/ListPagination'
import { registerVuexModule } from '@/utils/vuexUtils'
import { pagesHomeMixins } from '@/mixins/pagesHomeMixins'
import { obtainUserPermissions } from '@/utils/obtainUserPermissions'

import filasStore from '../_store'
import FilaHttpService from '../_services/filaHttpService'
import Dialog from '../_components/Dialog.vue'

export default {
  components: { ListPagination, Dialog },

  mixins: [pagesHomeMixins],

  data: () => ({
    permissaoTotal: false,
    headers: [
      {
        text: 'Fila',
        value: 'description',
        align: 'left',
      },
      {
        text: 'Estratégia',
        value: 'strategy',
        align: 'left',
      },
      {
        text: 'Prioridade',
        value: 'priority',
        align: 'right',
        sortable: false,
      },
      {
        text: 'Música de Espera',
        value: 'music',
        align: 'left',
        sortable: false,
      },
      {
        text: 'Ações',
        value: 'botoes',
        align: 'center',
        sortable: false,
      },
    ],
    dataFilas: [],
    strategy: {
      ringall: 'Tocar todos',
      leastrecent: 'Disponível por mais tempo',
      fewestcalls: 'Atendeu menos chamadas',
      random: 'Aleatoriamente',
      rrmemory: 'Sequência definida pelo usuário',
      rrordered: 'Ordenado',
      linear: 'Primeiro ramal livre da sequência',
    },
    arrayPermissaoTotal: [process.env.VUE_APP_CALLCENTER_CADASTRO_FILA_TOTAL, process.env.VUE_APP_ADMINISTRADOR],
    fila: {},
    dialog: false,
  }),

  computed: {
    ...mapGetters('filasHomeModuleCallCenterStore', ['getFilas', 'getMusicasEmEspera']),

    numberOfPages() {
      return Math.ceil(this.dataFilas.length / this.itemsPerPage)
    },
    qtdFilas() {
      return this.dataFilas.length
    },
  },

  async created() {
    registerVuexModule(this.$store, 'filasHomeModuleCallCenterStore', filasStore)
    await Promise.all([this.listarFilas(), this.listarMusicasEmEspera()])

    this.dataFilas = [...this.getFilas]

    this.dataFilas.forEach(fila => {
      fila.strategy = this.strategy[`${fila.strategy}`]
      fila.time = `${fila.time} s`
      if (fila.music !== 'default') {
        fila.music = this.getMusicasEmEspera.find(musicaEmEspera => musicaEmEspera._id === fila.music).description
      }
    })

    const arrayPermissions = this.arrayPermissionsFromLocalStorage()
    arrayPermissions.forEach(permissaoLocalStorage => {
      if (this.arrayPermissaoTotal.includes(permissaoLocalStorage)) {
        this.permissaoTotal = true
      }
    })

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('filasHomeModuleCallCenterStore', ['listarFilas', 'listarMusicasEmEspera', 'listarFilaUse']),
    ...obtainUserPermissions,

    handleGoToNewQueue(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const goToNewAudio = this.$router.resolve({ name: 'Fila/criar' })
        window.open(goToNewAudio.href, '_blank')
      } else {
        this.$router.push({ name: 'Fila/criar' })
      }
    },

    atualizar(event, item) {
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`fila/atualizar/${item.item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`fila/atualizar/${item.item._id}`)
      }
    },

    atualizarButton(event, item) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`fila/atualizar/${item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`fila/atualizar/${item._id}`)
      }
    },

    async deletar(item) {
      let resultado = window.confirm(`Deseja remover a fila "${item.description}"?`)
      if (resultado) {
        try {
          await FilaHttpService.deleteFila(item._id)
          this.dataFilas = this.dataFilas.filter(indexFila => indexFila._id !== item._id)
        } catch (error) {
          alert(error.response.data)
        }
      }
    },
    async openDialog(fila) {
      await this.listarFilaUse(fila._id)
      this.fila = fila
      this.dialog = true
    }
  },
}
</script>
